import {AxiosResponse} from "axios";

import ResourceApi from "@/src/modules/core/api/resource-api";
import axios from "@/src/modules/core/lib/axios";
import getParams from "@/src/modules/core/lib/params";
import {GetListResponse, GetResponse, ParamsOptions} from "@/src/modules/core/types";

import type {
  CompanyVehicle,
  CreateCompanyVehiclePayload,
  UpdateCompanyVehiclePayload,
  VehicleConditionCheckPayload,
  VehicleConditionCheckRow,
} from "../types";

const COMPANY_VEHICLES_PATH = "company-vehicles";
const VEHICLE_CONDITION_CHECKS_PATH = "vehicle-condition-checks";

class CompanyVehiclesApi extends ResourceApi<CompanyVehicle> {
  constructor() {
    super(COMPANY_VEHICLES_PATH);
  }

  list(options?: ParamsOptions): Promise<AxiosResponse<GetListResponse<CompanyVehicle>>> {
    return axios({
      url: COMPANY_VEHICLES_PATH,
      method: "get",
      params: getParams(options),
    });
  }

  create(
    data: CreateCompanyVehiclePayload,
  ): Promise<AxiosResponse<GetResponse<CompanyVehicle>>> {
    return super.create(data);
  }

  update(
    id: number,
    data: UpdateCompanyVehiclePayload,
  ): Promise<AxiosResponse<GetResponse<CompanyVehicle>>> {
    return super.update(id, data);
  }

  createConditionCheck(
    data: VehicleConditionCheckPayload,
  ): Promise<AxiosResponse<unknown>> {
    return this.createAt(VEHICLE_CONDITION_CHECKS_PATH, data);
  }

  listConditionChecks(
    options?: ParamsOptions,
  ): Promise<AxiosResponse<GetListResponse<VehicleConditionCheckRow>>> {
    return axios({
      url: VEHICLE_CONDITION_CHECKS_PATH,
      method: "get",
      params: getParams(options),
    });
  }

  /**
   * Scoped list: GET `company-vehicles/{companyVehicleId}/vehicle-condition-checks`
   */
  listConditionChecksForCompanyVehicle(
    companyVehicleId: number,
    options?: ParamsOptions,
  ): Promise<AxiosResponse<GetListResponse<VehicleConditionCheckRow>>> {
    return axios({
      url: `${COMPANY_VEHICLES_PATH}/${companyVehicleId}/${VEHICLE_CONDITION_CHECKS_PATH}`,
      method: "get",
      params: getParams(options),
    });
  }

  remove(id: number): Promise<AxiosResponse<unknown>> {
    return this.delete(id);
  }
}

export const companyVehiclesApi = new CompanyVehiclesApi();
